import classNames from 'classnames';
import { FunctionComponent, h } from 'preact';
import { useRef, useState } from 'preact/hooks';
import { useAccordionAttrs } from '../../hooks/useAccordionAttrs';

export const Foldable: FunctionComponent<{
  label: string;
}> = ({ label, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  const contentAttrs = useAccordionAttrs(contentRef, {
    isOpen,
    transitionDuration: '0.2s',
  });

  return (
    <div
      className={classNames('foldable', {
        openFoldable: isOpen,
      })}
    >
      <button className='foldable_button' onClick={() => setIsOpen((x) => !x)}>
        {label}
      </button>
      <div className='foldable_window' {...contentAttrs}>
        <div className='foldable_content' ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};
